<ul class="toast-list">
    <ng-container *ngFor="let toast of toasts()">
        <li>
            <div 
            class="toast"             
            @toastAnimation
            >
                <div class="toast__container" [ngClass]="toast.type">
                    <div>
                        <span class="toast__msg">{{ toast.titleMsg }}</span>
                        <span class="toast__secondaryMsg">{{ toast.message }}</span>                        
                    </div>
                    <div>
                        <span class="toast__close-icon" (click)="toastService.dismiss(toast.id)">
                            <img src="https://contentdeliveryciam.blob.core.windows.net/spark/close_icon.svg">
                        </span>                        
                    </div>
                </div>
            </div>            
        </li>
    </ng-container> 
</ul>